import React from 'react';
import * as LucideIcons from 'lucide-react';

/**
 * Icon — Design System icon wrapper around lucide-react.
 *
 * Usage:
 *   <Icon name="megaphone" size={20} />
 *   <Icon name="chevron-down" color="var(--primary-orange)" />
 *
 * Props:
 *   name        {string}  Lucide icon name in kebab-case (e.g. "arrow-right")
 *   size        {number}  Width & height in px (default: 20)
 *   strokeWidth {number}  Stroke width (default: 1.8)
 *   color       {string}  CSS color value (default: "currentColor")
 *   className   {string}  Extra CSS class
 */
function Icon({ name, size = 20, strokeWidth = 1.8, color = 'currentColor', className, ...rest }) {
  if (!name) return null;

  // Convert kebab-case to PascalCase: "arrow-right" → "ArrowRight"
  const pascalName = name
    .split('-')
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join('');

  const LucideIcon = LucideIcons[pascalName];

  if (!LucideIcon) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`[Icon] Unknown icon name: "${name}". Check https://lucide.dev/icons/ for valid names.`);
    }
    return null;
  }

  return (
    <LucideIcon
      size={size}
      strokeWidth={strokeWidth}
      color={color}
      className={className}
      {...rest}
    />
  );
}

export default Icon;
